<template>
  <div id="no-layout-container">
    <div class="logo-container">
      <LincolnEffortlessExperienceLogoDark />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import LincolnEffortlessExperienceLogoDark from '../components/LincolnEffortlessExperienceLogoDark.vue';

export default {
  name: 'BareLayout',
  components: { LincolnEffortlessExperienceLogoDark },
};
</script>

<style type="scss">
  html {
    height: 100%;
  }

  body {
    height: 100%;
    margin: 0;
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-size: 1rem;
  }

  #app {
    height: 100%;
  }

  #no-layout-container {
    height: 100%;
  }

  .logo-container {
    background-image: url('/assets/logoEffortlessExperienceDark.png');
    width: 353px;
    height: 77px;
    margin-top: 40px;
  }

</style>
